import React from "react";
import type {VoidFunctionComponent} from "react";
import {useFilterDifficultyDropdownMenuLogic} from "./FilterDifficultyDropdownMenu.logic";
import {DropdownFilterMenu} from "../../filters/dropdown-filter-menu/DropdownFilterMenu";
import {FilterDifficultyCategories} from "../filter-difficulty-categories/FilterDifficultyCategories";

export const FilterDifficultyDropdownMenu: VoidFunctionComponent = () => {
  const {label, onClickMenuToggleHandler, isActive, isAvailable, dropdownFilterMenuRef} = useFilterDifficultyDropdownMenuLogic();
  if (!isAvailable) {
    // not available for filter
    return null;
  }
  return <DropdownFilterMenu
    ref={dropdownFilterMenuRef}
    {...{label, onClickMenuToggleHandler, isActive}}
    component={FilterDifficultyCategories}
  />;
}
